import { motion } from "framer-motion";

/** Line-by-line masked reveal for editorial headlines. */
export default function RevealText({
  lines = [],
  delay = 0,
  className = "",
  lineClassName = "",
  as: Tag = "h1",
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className={`reveal-line ${lineClassName}`}>
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: [0.2, 0.7, 0.1, 1], delay: delay + i * 0.11 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
